import { Icon } from "../../Icon/Icon.interface";

interface AdminlItem {
  icon: Icon;
  link: string;
}

export const admin: AdminlItem[] = [
  {
    icon: "admin",
    link: "/admin",
  },
];
